"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var PORTAL_INSTALLS_URI = 'integrators/v1/portal-installs';

var IntegrationsAPI =
/*#__PURE__*/
function () {
  function IntegrationsAPI() {
    (0, _classCallCheck2.default)(this, IntegrationsAPI);
  }

  (0, _createClass2.default)(IntegrationsAPI, null, [{
    key: "getInstalledIntegrations",
    value: function getInstalledIntegrations() {
      return _apiClient.default.get(PORTAL_INSTALLS_URI);
    }
  }]);
  return IntegrationsAPI;
}();

exports.default = IntegrationsAPI;
module.exports = exports.default;